import React from "react"
import { useSelector } from "react-redux"

import Pricing from "@/pricing"
import { getProductNetCurrencyCode } from "@/onboarding/features/product/selectors"

// A component's ratesheet, with amounts in the product's net currency: the same
// fallback RateDisplay uses when the tour Costs section shows these rates.
const ComponentRatesView = ({ ratesheet, previousValues = false }): JSX.Element => {
  const netCurrency = useSelector(getProductNetCurrencyCode)

  return (
    <Pricing.View value={ratesheet} previousValues={previousValues} currencyCode={netCurrency} />
  )
}

export default ComponentRatesView
